/**
 * Ordered list items in post content are authored as "title<br>description".
 * Figma renders the description flush with the list's own left edge (no
 * hanging indent under the marker/title), which plain CSS can't express for
 * text that's split by a <br> inside one <li> — so we wrap everything after
 * the first <br> in a span we can un-indent with a negative margin.
 *
 * @return {void}
 */
export const initListDescriptionIndent = () => {

	const items = document.querySelectorAll( '.wp-block-list li' );

	items.forEach( ( item ) => {

		const br = item.querySelector( 'br' );

		if ( ! br ) {

			return;

		}

		const wrapper = document.createElement( 'span' );
		wrapper.className = 'wp-block-list__description';

		while ( br.nextSibling ) {

			wrapper.appendChild( br.nextSibling );

		}

		item.appendChild( wrapper );

	} );

};
